import { All, AuthActionTypes } from './auth.actions';
import { Error } from '@coreModels/error';
import { AuthenticatedUser } from '@models/authenticated-user';

export interface UserState {
  isAuthenticated: boolean;
  user: AuthenticatedUser | null;
  errorMessage?: string | null;
  companies?: any;
  successMessage?: string | null;
  errors?: Error[] | null;
}

export const initialState: UserState = {
  isAuthenticated: false,
  user: null,
  errorMessage: null,
  successMessage: null,
};

const loadInitialState = (): UserState => {
  const user = JSON.parse(localStorage.getItem('user'));
  if (user) {
    return {
      ...initialState,
      isAuthenticated: true,
      user,
    };
  }

  return { ...initialState } as UserState;
};

export function reducer(state = loadInitialState(), action: All): UserState {
  state = {
    ...state,
    errors: [],
  };

  switch (action.type) {
    case AuthActionTypes.LOGIN_SUCCESS: {
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload as AuthenticatedUser,
        errorMessage: null,
      };
    }
    case AuthActionTypes.LOGIN_FAILURE: {
      return {
        ...state,
        errorMessage: 'Invalid email address or password',
      };
    }
    case AuthActionTypes.LOGIN_FAILURE_LOCKED: {
      return {
        ...state,
        errorMessage: 'Account locked!',
      };
    }
    case AuthActionTypes.LOGOUT_SUCCESS: {
      return {
        ...initialState,
      };
    }
    case AuthActionTypes.PASSWORD_REQUEST_SUCCESS: {
      return {
        ...state,
        successMessage:
          'If your email address exists in our database, you will receive a password recovery link' +
          ' at your email address in a few minutes',
      };
    }
    // todo: remove this - BE always need to return status 200 and we will show success message
    case AuthActionTypes.PASSWORD_REQUEST_FAILURE: {
      return {
        ...state,
        errors: [{ scope: 'email', message: 'Invalid email' }],
      };
    }
    case AuthActionTypes.GET_ME_SUCCESS: {
      return {
        ...state,
        user: {
          ...state.user,
          ...action.payload,
        },
      };
    }
    case AuthActionTypes.UPDATE_ME_SUCCESS: {
      return {
        ...state,
      };
    }
    case AuthActionTypes.CHANGE_PASSWORD: {
      return {
        ...state,
        successMessage: null,
      };
    }
    case AuthActionTypes.CHANGE_PASSWORD_SUCCESS: {
      return {
        ...state,
        successMessage: 'Password changed successfully',
      };
    }
    case AuthActionTypes.PASSWORD_RESET_FAILURE:
    case AuthActionTypes.CHANGE_PASSWORD_FAILURE: {
      return {
        ...state,
        errors: action.payload.errors,
      };
    }
    case AuthActionTypes.RESET_MESSAGES: {
      return {
        ...state,
        successMessage: null,
        errorMessage: null,
      };
    }
    default: {
      return state;
    }
  }
}
